
export default [
  {
    id: 'rhythmic-improvisations',
    title: 'Rhythmic Improvisations',
    image: '/assets/images/THUMBS/RIFromLeftT.jpg',
    category: 'In Situ',
    detail: <div>
      November 2006: A wallhanging for the Vermont Jazz Center in Brattleboro VT
      <br /><br />
      There's a wonderful performance space in Brattleboro VT, located in a factory building which has been converted to a conglomeration of artists' studios and other interesting spaces. This hotbed of the arts is The Cotton Mill, located off South Main Street.
    </div>,
    variations:[
      {
        image: '/assets/images/other/RIFromLeft.jpg',
        description: <div>
            In the fall of '07, my husband helped to give the space a new coat of paint, and caught wind of the need for "something" on the wall to liven things up. I decided to make a large (12 feet wide by 9 feet high!), simple piece (three lengths of hand-dyed cloth, hung with strips of black fabric seperating them). The three pieces are all done with a twisting technique, a good method for dyeing large pieces of fabric with an interesting, rhythmic coloration. Above, you see the piece in the performance space, and below is a larger image of the finished piece:
        </div>
      },
      {
        image: '/assets/images/other/RhythmicImprovisations.jpg',
        description: <div>
            Rhythmic Improvisations
<br /><br />
12' x 9', artist-dyed cotton fabric
        </div>
      },
      {
        image: '/assets/images/other/RIWithPerson.jpg',
      }
    ]
  },
  {
    id: 'chromatic-morphogenesis',
    title: 'Chromatic Morphogenesis',
    image: '/assets/images/other/StaffordDown.jpg',
    category: 'In Situ',
    detail: <div>
This set of pieces hangs in a common space at the Stafford Building (molecular biology and genetics) at the University of Vermont in Burlington. The name was the result of a contest held during the grand "opening" of these pieces.
<br /><br />
They are pieced from my own hand-dyed cotton fabrics, and filled with a thin cotton batting.
    </div>,
    variations:[
      {
        image: '/assets/images/other/StaffordDown.jpg',
        description: <div>
            View from 1st floor eating area
        </div>
      },
      {
        image: '/assets/images/other/StaffordUp.jpg',
        description: <div>
            View from 2nd floor
        </div>
      },
      {
        image: '/assets/images/other/BarreHospitalHangings.jpg',
        description: <div>
            Above is another set of hangings in a public place, namely the hospital in Barre Vermont. These are stretched on wooden frames, as one would mount canvases.
        </div>
      },
    ]
  },
  {
    id: 'sky-grid',
    title: 'Sky Grid',
    image: '/assets/images/other/SkyGridInSitu.jpg',
    category: 'In Situ',
    variations:[
      {
        image: '/assets/images/other/SkyGridInSitu.jpg',
        description: <div>
Above is Sky Grid, a pattern which I've mostly done as a bedquilt -- but here it's a hanging.
        </div>
      },
    ]
  },
  {
    id: 'monet',
    title: 'Monet',
    image: '/assets/images/other/MonetAtMoms.jpg',
    category: 'In Situ',
    variations:[
      {
        title: 'Monet',
        image: '/assets/images/other/MonetAtMoms.jpg',
      },
    ]
  },
]